export default __webpack_public_path__ + "static/media/BeforePhoto2.5bd23ec8.jpg";